import { KeyboardState } from "./type";

export const getPipe = (state: KeyboardState) => state.pipe;

export const getEnterFunction = (state: KeyboardState) => state.enterFunction;

export const getFocusedElementId = (state: KeyboardState) => state.focusedElementId;


// WEBPACK FOOTER //
// ./src/store/Keyboard/selectors.ts